var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-details-card"},[(_vm.details)?_c('div',[_vm._l((_vm.details),function(detail){return [_c('featured-text-row',_vm._b({key:detail.handle},'featured-text-row',detail,false))]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }